import { render, staticRenderFns } from "./BusinessCommissionPage.vue?vue&type=template&id=38e23726&"
import script from "./BusinessCommissionPage.vue?vue&type=script&lang=js&"
export * from "./BusinessCommissionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38e23726')) {
      api.createRecord('38e23726', component.options)
    } else {
      api.reload('38e23726', component.options)
    }
    module.hot.accept("./BusinessCommissionPage.vue?vue&type=template&id=38e23726&", function () {
      api.rerender('38e23726', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FinanceManage/BusinessCommission/BusinessCommissionPage.vue"
export default component.exports